/* eslint-disable */
$(document).ready(function () {
  document.title = "列管污染源資料 (含裁處資訊) 查詢系統-PRTR智能客服"
  
  PageInit();
});

function PageInit() {
  initWebChat();
}

function initWebChat() {
  // --------- API 路徑 ---------
  var LOGIN_URL = `${aichatapihost}api/auth/login`;
  var ASK_URL = `${aichatapihost}api/AIChat/ask`;
  var FEEDBACK_URL = `${aichatapihost}api/AIChat/feedback`;

  // --------- AI 服務回饋 SDK 設定 ---------
  // serviceId 綁定登記的網域（https://prtr.moenv.gov.tw），其他網域送出會回 400 serviceId and Origin Mismatch
  var FEEDBACK_SERVICE_ID = "moenv-prtr-webchat";
  var FEEDBACK_DSN = "https://aifeedback.nics.nat.gov.tw/api";
  // 資安院不開放測試站，非正式站一律模擬送出
  var FEEDBACK_IS_PROD = window.location.host.includes("moenv");

  // --------- 狀態 ---------
  var isWaiting = false;
  var lastActivity = Date.now();
  var remindTimer = null;
  var endTimer = null;
  var hasAsked = false;
  var feedbackReady = initFeedbackSdk();
  var responseSecs = []; // 本輪對話每次「送出 → 回覆顯示」的秒數
  var feedbackSubmitted = false; // 本輪是否已送出回饋（一輪只填一次）
  var $feedbackCard = null; // 尚未送出的回饋卡，每次回答後移到最新回覆下方

  // --------- Token store ---------
  var store = { token: "", expireAt: 0 };

  // --------- DOM ---------
  var $chat = $(".webchat");
  var $messages = $chat.find("#chat-messages");
  var $input = $chat.find("#userInput");
  var $send = $chat.find("#sendButton");
  var $end = $chat.find("#endChatButton");
  var $suggest = $chat.find("#suggested-questions");

  // 輸入框預設提示
  $input.attr("placeholder", "請輸入想查詢的內容，例如：「怎麼查某家公司裁處資訊？」");

  // --------- 建議問題清單 ---------
  var SUGGESTED_QUESTIONS = [
    {
      label: "怎麼查某家公司的基本資料？",
      question: "我想查詢某事業在PRTR系統的基本資料，該如何查詢？",
    },
    {
      label: "如何查某公司的裁處紀錄？",
      question: "我想查詢某公司的裁處紀錄，該如何查詢？",
    },
    {
      label: "PRTR智能客服有提供什麼樣的服務？",
      question: "PRTR智能客服目前有提供什麼服務？可以簡單說明一下嗎？",
    },
  ];

  // 一開始先鎖住輸入，等授權成功才開放
  setChatEnabled(false);

  // --------- 事件委派：重啟對話按鈕 ---------
  $(document)
    .off("click", ".restart-btn")
    .on("click", ".restart-btn", function (e) {
      e.preventDefault();
      restartChatFlow();
    });

  // 建議問題按鈕點擊事件
  if ($suggest && $suggest.length) {
    // 建議問題按鈕：送出問題
    $suggest.off("click", ".suggest-btn").on("click", ".suggest-btn", function () {
      if ($input.prop("disabled")) return; // 尚未授權或對話已結束

      var q = $(this).data("question") || $(this).text() || "";
      q = (q || "").trim();
      if (!q) return;

      $input.val(q);
      sendMessage();
    });

    // 重新呼叫按鈕：再顯示建議問題
    $suggest.off("click", ".suggest-recall-btn").on("click", ".suggest-recall-btn", function () {
      // 重新顯示建議問題，並視為「還沒問過」的狀態
      hasAsked = false;
      renderSuggestions();
    });
  }

  // 先顯示一個「載入中 / 思考中」的氣泡
  var initThinking = appendThinking();

  // 嘗試登入拿 token
  loginOnce()
    .then(function () {
      // 登入成功 → 開啟聊天 & 顯示歡迎訊息＋建議問題
      setChatEnabled(true);
      lastActivity = Date.now();
      hasAsked = false; // 確保是新的一輪
      initThinking.setAnswer(getWelcomeMessage());
      renderSuggestions();
      startIdleTimers();
    })
    .catch(function () {
      // 登入失敗，保持鎖定 & 顯示錯誤
      setChatEnabled(false);
      initThinking.setError("授權失敗，目前無法提供服務，請稍後重新整理頁面再試。");
    });

  // 綁事件
  $send.on("click", sendMessage);
  $end.on("click", onEndChat);
  $input.on("keydown", function (e) {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      sendMessage();
    } else {
      lastActivity = Date.now();
    }
  });

  /* ================= 控制聊天啟用狀態 ================= */
  function setChatEnabled(enabled) {
    $input.prop("disabled", !enabled);
    $send.prop("disabled", !enabled);
  }

  /* ================= 歡迎訊息 ================= */
  function getWelcomeMessage() {
    return [
      "歡迎來到 PRTR 智能客服，我可以幫你查詢和說明 PRTR 系統相關資訊：",
      "",
      "我可以協助你：",
      "- 查詢列管事業的基本資料與裁處資訊",
      "- 說明PRTR 統的功能、操作方式與資料來源",
      "",
      "你也可以這樣問我：",
      "- 「幫我查某某公司在PRTR系統的基本資料」",
      "- 「怎麼在PRTR系統查詢列管事業的污染源申報資料？」",
      "- 「某某某公司的某年裁處資訊？」",
    ].join("\n");
  }

  /* ================= 建議問題按鈕 ================= */
  function renderSuggestions() {
    if (!$suggest || !$suggest.length) return;

    $suggest.empty();

    // 外層容器：讓三顆按鈕並排
    var $wrapper = $('<div class="suggest-btn-wrapper"></div>');

    SUGGESTED_QUESTIONS.forEach(function (item) {
      var $btn = $('<button type="button" class="suggest-btn"></button>').text(item.label).data("question", item.question);

      $wrapper.append($btn);
    });

    $suggest.append($wrapper);
  }

  /* ================= 重新呼叫建議問題按鈕 ================= */
  function renderSuggestRecallButton() {
    if (!$suggest || !$suggest.length) return;

    $suggest.empty();

    var $btn = $('<button type="button" class="suggest-recall-btn">顯示建議問題</button>');
    // 不在這裡綁 click，統一用事件委派（下面會補）
    $suggest.append($btn);
  }

  /* ================= 登入一次 ================= */
  function loginOnce() {
    return $.ajax({
      url: LOGIN_URL,
      method: "POST",
      timeout: 20000,
    }).then(function (data) {
      var payload = data && data.data ? data.data : data;
      store.token = payload && payload.JwtToken ? payload.JwtToken : "";
      store.expireAt = Date.parse(payload && payload.ExpireTime ? payload.ExpireTime : "") || 0;

      try {
        if (store.token) {
          sessionStorage.setItem("AccessToken", store.token);
          sessionStorage.setItem("AccessTokenExpire", String(store.expireAt));
        }
      } catch (e) {}

      return payload;
    });
  }

  function getToken() {
    if (store.token) return store.token;
    try {
      store.token = sessionStorage.getItem("AccessToken") || "";
    } catch (e) {}
    return store.token;
  }

  /* ================= UI：訊息泡泡 ================= */
  function appendMessage(role, htmlText, opts = {}) {
    var time = formatTime(new Date());
    var $wrap = $("<div>").addClass("message").addClass(role);

    if (role === "bot") {
      var $avatar = $("<div>").addClass("message-avatar").append($("<img>").attr({"src": "/img/Bot.png", "alt": "PRTR 智能客服"}));
      $wrap.append($avatar);
    }

    var $content = $("<div>").addClass("message-content");
    var $bubble = $("<div>").addClass("message-bubble");

    if (role === "bot") {
      var html = opts.rawHtml ? htmlText || "" : renderMarkdown(htmlText || "");
      $bubble.html(html);
    } else {
      $bubble.text(htmlText || "");
    }

    var $time = $("<div>").addClass("message-time").text(time);
    $content.append($bubble).append($time);
    $wrap.append($content);
    $messages.append($wrap);
    scrollToBottom();
    return $bubble;
  }

  /* ============ 思考中 + 即時顯示時間 ============ */
  function appendThinking() {
    var $wrap = $("<div>").addClass("message bot");
    var $avatar = $("<div>").addClass("message-avatar").append($("<img>").attr({"src": "/img/Bot.png", "alt": "PRTR 智能客服"}));
    var $content = $("<div>").addClass("message-content");
    var $bubble = $("<div>").addClass("message-bubble");
    var $time = $("<div>").addClass("message-time").text(formatTime(new Date()));

    var $typing = $('<div class="typing-indicator">' + '<div class="typing-content">' + '<span class="status-text">思考中</span>' + '<div class="dots"><div class="dot"></div><div class="dot"></div><div class="dot"></div></div>' + "</div>" + "</div>");

    $bubble.append($typing);
    $content.append($bubble).append($time);
    $wrap.append($avatar).append($content);
    $messages.append($wrap);
    scrollToBottom();

    function updateTime() {
      $time.text(formatTime(new Date()));
    }

    return {
      setAnswer: function (html) {
        $typing.remove();
        $bubble.html(renderMarkdown(html || ""));
        updateTime();
      },
      setError: function (msg, opts = {}) {
        $typing.remove();
        if (opts.rawHtml) {
          $bubble.html(msg || "");
        } else {
          $bubble.text(msg || "目前系統使用人數較多，請稍後再試。");
        }
        updateTime();
      },
    };
  }

  /* ================= Idle 計時 ================= */
  function startIdleTimers() {
    clearTimeout(remindTimer);
    clearTimeout(endTimer);

    remindTimer = setTimeout(
      function () {
        if (Date.now() - lastActivity >= 8 * 60 * 1000) {
          appendMessage("bot", "您好，請問還有其他問題需要為您服務的嗎？");
        }
      },
      8 * 60 * 1000
    );

    endTimer = setTimeout(
      function () {
        if (Date.now() - lastActivity >= 10 * 60 * 1000) {
          appendMessage("bot", '本次交談已結束，若還有需要服務，請點選 <button class="restart-btn" type="button">【重啟對話】</button>。', { rawHtml: true });
          disableChat();
        }
      },
      10 * 60 * 1000
    );
  }

  function disableChat() {
    setChatEnabled(false);
    $end.prop("disabled", false).text("開始對話");
    clearTimeout(remindTimer);
    clearTimeout(endTimer);
    removeFeedbackCard(); // 對話結束（手動或閒置），未填的回饋卡一併收掉
  }

  /* ================= 重啟對話 Flow ================= */
  function restartChatFlow() {
    // 先重置 UI，但先不要開啟輸入
    restartChatUIOnly();
    setChatEnabled(false);
    hasAsked = false;

    var thinking = appendThinking();

    loginOnce()
      .then(function () {
        setChatEnabled(true);
        lastActivity = Date.now();
        thinking.setAnswer(getWelcomeMessage());
        renderSuggestions();
        startIdleTimers();
      })
      .catch(function () {
        setChatEnabled(false);
        thinking.setError('授權失敗，請稍後再試或點擊 <button type="button" class="inline-restart-btn">開始對話</button> 重新授權。', { rawHtml: true });
        $end.prop("disabled", false).text("開始對話");
      });
    $(document)
      .off("click", ".inline-restart-btn")
      .on("click", ".inline-restart-btn", function () {
        restartChatFlow();
      });
  }

  function restartChatUIOnly() {
    $messages.empty();
    $input.val("");
    $end.text("結束對話");
    responseSecs = [];
    feedbackSubmitted = false;
    $feedbackCard = null;
    clearTimeout(remindTimer);
    clearTimeout(endTimer);
    if ($suggest && $suggest.length) {
      $suggest.empty(); // 清掉舊的建議按鈕
    }
  }

  /* ================= 發送 ================= */
  function sendMessage() {
    if ($input.prop("disabled")) return; // 未授權或已結束
    if (isWaiting) return;

    var text = ($input.val() || "").trim();
    if (!text) return;

    // 第一次真的送出問題時，把三顆按鈕收掉，換成「顯示建議問題」按鈕
    if (!hasAsked) {
      hasAsked = true;
      if ($suggest && $suggest.length) {
        renderSuggestRecallButton();
      }
    }
    appendMessage("user", text); // 使用者訊息以 .text() 顯示，不需再跳脫
    $input.val("");
    lastActivity = Date.now();
    startIdleTimers();

    isWaiting = true;
    $send.prop("disabled", true);

    var botUI = appendThinking();
    var headers = { "Content-Type": "application/json" };
    var tk = getToken();
    if (tk) headers.Authorization = "Bearer " + tk;

    var DEFAULT_MSG = "目前系統使用人數較多，請稍後再試或重新整理頁面。";
    var askStartAt = Date.now();

    $.ajax({
      url: ASK_URL,
      method: "POST",
      headers: headers,
      data: JSON.stringify({ prompt: text }),
      timeout: 180000,
      dataType: "json",
    })
      .done(function (data) {
        try {
          if (typeof data === "string") {
            try {
              data = JSON.parse(data);
            } catch (e) {}
          }
          var msg = (data && typeof data === "object" && data.output && String(data.output).trim()) || (typeof data === "string" && data.trim()) || DEFAULT_MSG;
          botUI.setAnswer(msg);
          responseSecs.push((Date.now() - askStartAt) / 1000);
          showFeedbackCard();
        } catch (e) {
          botUI.setAnswer(DEFAULT_MSG);
        }
      })
      .fail(function () {
        botUI.setError(DEFAULT_MSG);
      })
      .always(function () {
        isWaiting = false;
        if (!$input.prop("disabled")) {
          $send.prop("disabled", false);
        }
        scrollToBottom();
      });
  }

  function onEndChat() {
    if ($end.text() === "開始對話") {
      // 使用者點「開始對話」→ 重啟 & 重新授權
      restartChatFlow();
      return;
    }
    appendMessage("bot", '本次交談已結束，若還有需要服務，請點選 <button class="restart-btn" type="button">【重啟對話】</button>。', { rawHtml: true });

    disableChat();
  }

  /* ================= AI 服務回饋 ================= */
  function initFeedbackSdk() {
    if (!window.FeedbackSDK) return false;
    try {
      window.FeedbackSDK.init({ serviceId: FEEDBACK_SERVICE_ID, dsn: FEEDBACK_DSN });
      return true;
    } catch (e) {
      console.warn("FeedbackSDK 初始化失敗", e);
      return false;
    }
  }

  function submitFeedback(data) {
    saveFeedbackToDb(data); // 另存一份到自己的資料庫，測試站也會實際寫入
    if (FEEDBACK_IS_PROD) return window.FeedbackSDK.submit(data);

    console.info("[FeedbackSDK 模擬送出] 非正式站不會實際送出，資料：", data);
    return new Promise(function (resolve) {
      setTimeout(function () {
        resolve({});
      }, 1000);
    });
  }

  // 存檔失敗只記 log，不影響畫面上的回饋流程
  function saveFeedbackToDb(data) {
    // token 有效期只有 10 分鐘，聊完放著再送出可能已過期，先重新登入
    var expired = !getToken() || (store.expireAt && Date.now() >= store.expireAt);
    var ready = expired ? loginOnce() : $.Deferred().resolve().promise();

    ready
      .then(function () {
        var headers = { "Content-Type": "application/json" };
        var tk = getToken();
        if (tk) headers.Authorization = "Bearer " + tk;

        return $.ajax({
          url: FEEDBACK_URL,
          method: "POST",
          headers: headers,
          data: JSON.stringify(data),
          timeout: 20000,
        });
      })
      .fail(function (xhr) {
        console.warn("回饋存檔失敗", xhr && xhr.status);
      });
  }

  function getAvgResponseSec() {
    var total = responseSecs.reduce(function (sum, s) {
      return sum + s;
    }, 0);
    return Math.round((total / responseSecs.length) * 100) / 100;
  }

  // 每次回答後呼叫：本輪尚未送出回饋時，把回饋卡放到最新回覆下方（只保留一張，已填內容會保留）
  function showFeedbackCard() {
    if (!feedbackReady || feedbackSubmitted) return;
    if ($input.prop("disabled")) return; // 等待回覆期間使用者已結束對話

    if (!$feedbackCard) $feedbackCard = createFeedbackCard();
    $messages.append($feedbackCard);
    scrollToBottom();
  }

  function removeFeedbackCard() {
    if (!$feedbackCard) return;
    $feedbackCard.remove();
    $feedbackCard = null;
  }

  function createFeedbackCard() {
    var RATINGS = [
      { value: "good", label: "滿意", emoji: "👍" },
      { value: "normal", label: "普通", emoji: "😐" },
      { value: "bad", label: "不滿意", emoji: "👎" },
    ];
    var ERROR_MSG = {
      INVALID_DATA: "回饋內容格式有誤，請確認後再送出。",
      UNAUTHORIZED: "回饋服務驗證失敗，請稍後再試。",
      SUBMISSION_CONFLICT: "此回饋已送出過，請勿重複送出。",
    };
    var rating = "";

    // 回饋卡獨立於對話泡泡之外（依 Figma 設計稿）
    var $card = $('<div class="feedback-card"></div>');
    var $title = $('<p class="feedback-title" id="feedback-title">本次服務是否對您有幫助？</p>');
    var $panel = $('<div class="feedback-panel"></div>');
    var $ratings = $('<div class="feedback-ratings" role="group" aria-labelledby="feedback-title"></div>');
    var $comment = $('<input type="text" class="feedback-comment" maxlength="500" placeholder="其他回饋意見" aria-label="其他回饋意見（選填，500 字以內）" />');
    var $submit = $('<button type="button" class="feedback-submit" disabled>送出</button>');
    var $status = $('<p class="feedback-status" role="status" aria-live="polite"></p>');

    RATINGS.forEach(function (item) {
      $('<button type="button" class="feedback-rating-btn" aria-pressed="false"></button>')
        .attr("aria-label", item.label)
        .text(item.label + " " + item.emoji)
        .data("rating", item.value)
        .appendTo($ratings);
    });

    $ratings.on("click", ".feedback-rating-btn", function () {
      rating = $(this).data("rating");
      $ratings.find(".feedback-rating-btn").removeClass("is-active").attr("aria-pressed", "false");
      $(this).addClass("is-active").attr("aria-pressed", "true");
      $submit.prop("disabled", false);
    });

    $submit.on("click", function () {
      if (!rating) return;

      // 送出當下才計算，涵蓋本輪到目前為止的所有回覆
      var data = { feedbackRating: rating, inferenceSec: getAvgResponseSec() };
      var comment = ($comment.val() || "").trim();
      if (comment) data.feedbackComment = comment;

      $submit.prop("disabled", true).text("送出中…");
      $status.text("");

      submitFeedback(data)
        .then(function () {
          // 送出期間若已結束或重啟對話，這張卡已不屬於本輪，不影響新一輪的狀態
          if ($feedbackCard !== $card) return;
          feedbackSubmitted = true;
          $feedbackCard = null; // 感謝訊息留在原處，之後的回答不再移動它
          $card.addClass("is-done").empty().append('<p class="feedback-done" role="status">已收到您的回饋，謝謝！</p>');
        })
        .catch(function (err) {
          console.warn("FeedbackSDK 送出失敗", err);
          $status.text(ERROR_MSG[err && err.code] || "回饋送出失敗，請稍後再試。");
          $submit.prop("disabled", false).text("送出");
        });
    });

    $panel.append($ratings, $comment, $submit, $status);
    $card.append($title, $panel);
    return $card;
  }

  /* ================= 小工具 ================= */
  function formatTime(d) {
    try {
      return d.toLocaleTimeString("zh-TW", {
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: false,
      });
    } catch (e) {
      var hh = ("0" + d.getHours()).slice(-2);
      var mm = ("0" + d.getMinutes()).slice(-2);
      var ss = ("0" + d.getSeconds()).slice(-2);
      return hh + ":" + mm + ":" + ss;
    }
  }

  function scrollToBottom() {
    try {
      if ($messages && $messages.length && $messages[0]) {
        $messages.scrollTop($messages[0].scrollHeight);
      }
    } catch (e) {}
  }

  function escapeHtml(str) {
    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#039;");
  }

  function renderMarkdown(md) {
    try {
      if (typeof window !== "undefined" && window.marked && typeof window.marked.setOptions === "function") {
        window.marked.setOptions({ gfm: true, breaks: true });
      }

      var html = "";
      if (typeof window !== "undefined" && window.marked) {
        if (typeof window.marked.parse === "function") {
          html = window.marked.parse(md || "");
        } else if (typeof window.marked === "function") {
          html = window.marked(md || "");
        } else {
          html = md || "";
        }
      } else {
        html = md || "";
      }

      if (typeof window !== "undefined" && window.DOMPurify && typeof window.DOMPurify.sanitize === "function") {
        return window.DOMPurify.sanitize(html, {
          ALLOWED_TAGS: ["p", "br", "strong", "em", "a", "ul", "ol", "li", "hr", "code", "pre", "table", "thead", "tbody", "tr", "th", "td"],
          ALLOWED_ATTR: ["href", "title", "target", "align", "colspan", "rowspan"],
        });
      }
      return html;
    } catch (e) {
      return escapeHtml(md || "");
    }
  }
}
